export const STATE_IDENTIFIER = {
  QUESTIONS: "questions",
  QUESTIONS_LOADER: "questionsLoader",
  ANSWER: "answer",
  REQUEST_STATE: "requestState",
};

export const LIST_IDENTIFIER = "list";
export const LOADER_IDENTIFIER = "loader";
